import axios from "axios";
//GET ALL CARCATAGORY BY COUNTRY
export const ADD_SESSION_OF_CASE = "ADD_SESSION_OF_CASE";
export const ADD_SESSION_OF_CASE_LOADING =
"ADD_SESSION_OF_CASE_LOADING";
export const ADD_SESSION_OF_CASE_LOADING_FAILED =
"ADD_SESSION_OF_CASE_LOADING_FAILED";

// HELPER ACTIONS CREATORS
//************************************** /

export const addSessionLoading = ms => ({
    type: ADD_SESSION_OF_CASE_LOADING,
    payload: ms
    });
    
    export const addSessionLoadingFailed = ms => ({
    type: ADD_SESSION_OF_CASE_LOADING_FAILED,
    payload: ms
    });

// RIDER PHINE NUBER
export function addSession(obj) {
    const request = axios.post(
    `https://prod-legalemirates.wowets.com/fileService/receptionistRoutes/api/v1/caseSessions/createSession`,obj, {
        headers: { 'Authorization': 'bearer ' +localStorage.receptionistToken}
      });
    return dispatch => {

    dispatch(addSessionLoading());
    request
    .then(response => {   
  
    if (response.status == 201 || response.status == 200) {
     console.log(response,"response addSession")
    dispatch({
    type: ADD_SESSION_OF_CASE,
    payload: response.data
    });
  
    } else {
      
    throw new Error(JSON.stringify(response.data.response.msg));
    }
    })
    .catch(error => {
        
    if (error.response) {
    if (error.response.status == "404") {
        console.log(error.response)
    dispatch(
        addSessionLoadingFailed(error.response.data.message)
    );
    } else {
    dispatch(addSessionLoadingFailed(error.response.data.message));
    }
    console.log(error.response.data);
    console.log(error.response.status);
    console.log(error.response.headers);
    } else if (error.request) {
    /*
    * The request was made but no response was received, `error.request`
    * is an instance of XMLHttpRequest in the browser and an instance
    * of http.ClientRequest in Node.js
    */
    dispatch(addSessionLoadingFailed(error.request));
    
    console.log(error.request);
    } else {
    // Something happened in setting up the request and triggered an Error
    console.log("Error", error.message);
    dispatch(addSessionLoadingFailed(error.message));
    }
    console.log(error);
    });
    };
    }


